/* lua.js generated code undefined */
//用户协议和隐私政策共用面板
require("clover/panel/component/common/UIGroupButton")

var ButtonPushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
require("clover/panel/base/BasePanel")
var instance = null
let [TextAreaWidth, TextAreaHeight] = [560, 650]
let TopAreaHeight = 650

//两种面板图片数量
var UserLength = 24
var PrivacyLength = 28
var perlength = 1000



let PrivacyPanel = xClass("PrivacyPanel", BasePanel, function () {
    let __VA_ARG = $slice(arguments, 0)
    // WARN: maybe multi result
    return cc.Node.create()
})

let RES = table()
PrivacyPanel.getRes = function (entry) {
    // 3公司主体是乐响  4公司主体是乐元素（目前只有微信 qq主体是乐元素 且微信是用自己的用户协议）
    let use4 = false
    if (window.mini){
        let pf = getCurrentPlatform()
        if (pf == MiniPlatform.qqlightGame || pf == MiniPlatform.tt || pf == MiniPlatform.ks){
            use4 = true
        }
    }    
    let folder = use4 ? "imagesPrivacy4" :  "imagesPrivacy3"
    RES = table()
    if (entry == "userAgreement"){
        for (let i = 0; i < UserLength; i++) {
            table.insert(RES,`${folder}/user_${i}.png`)
        }
    }else{
        for (let i = 0; i < PrivacyLength; i++) {
            table.insert(RES,`${folder}/privacy_${i}.png`)
        }
    }

    return RES
}


PrivacyPanel.preloadRes = function (entry, onSuccess, onFail, onCancel, useMask = false) {
    preloadWithLoading(this.getRes(entry), onSuccess, onFail, onCancel, useMask)
}

PrivacyPanel.prototype.ctor = function (entry, closeCb) {
    let self = this
    self.privacy_config = PrivacyUtil.getPrivacy_config()

    BasePanel.prototype.ctor.call(self);
    
    self.initUI(closeCb);
    self.initTxt(entry)



}
 
PrivacyPanel.prototype.onClose = function (callback) {
    let self = this
    ResManager.release(RES); //资源释放

    self.removeAllChildren()
    self.removeFromParent()
    if (callback) {
        callback()
    }
}

PrivacyPanel.prototype.popup = function () {
    let self = this
    self.setZOrder(1000)
    let size = cc.Director.getInstance().getVisibleSize()
	self.setPosition(size.width / 2, size.height / 2)
    
    //popup动画
    self.bg.setScale(0.1)
    self.bg.runAction(cc.EaseSineOut.create(cc.scaleTo(0.2, 1)))
    console.log("privacy selfbg", self.bg)
    
    var curScene = cc.Director.getInstance().getRunningScene()
    curScene.addChild(self)

    // var visibleSize = cc.Director.getInstance().getVisibleSize()
    var swallowLayer = cc.Layer.create()
    swallowLayer.setTouchEnabled(true)
    swallowLayer.setContentSize(size)
    self.addChild(swallowLayer)
    swallowLayer.setLocalZOrder(-1)
    function onTouchBegan(touch, event) {
        cc.log("点击")
        return true
    }
    function onTouchEnded(touch, event) {

    }
    var listener = cc.EventListenerTouchOneByOne.create()
    listener.setSwallowTouches(true)
    listener.registerScriptHandler(onTouchBegan, cc.Handler.EVENT_TOUCH_BEGAN)
    listener.registerScriptHandler(onTouchEnded, cc.Handler.EVENT_TOUCH_ENDED)
    cc.eventManager.addListener(listener, swallowLayer)

	return self

}


PrivacyPanel.prototype.initUI = function (closeCb) {
    let self = this

    let bg = ccui.Scale9Sprite.createWithSpriteFrameName("commonLib/privacy_bg.png", cc.rect(20, 16, 16, 16))
    bg.setContentSize(cc.size(680, 940))
    bg.setPosition(0,0)
    self.addChild(bg)
    self.bg = bg

    let white = ccui.Scale9Sprite.createWithSpriteFrameName("commonLib/privacy_white_bg.png", cc.rect(50, 50, 24, 24))
    white.setContentSize(cc.size(621, 693))
    white.setAnchorPoint(0.5, 0.5)
    white.setPosition(340, 510)
    self.bg.addChild(white)

    let btn = ccui.Scale9Sprite.createWithSpriteFrameName("commonLib/privacy_agree_btn.png", cc.rect(32, 36, 1, 1))
    btn.setContentSize(cc.size(219, 72))
    btn.setPosition(330, 70)
    self.bg.addChild(btn)
    let label = cc.Label.createWithSystemFont(self.privacy_config["privacy.agreebtn.txt"], "", 25)
    label.setTextColor(cc.c4b(255, 255, 255, 255))
    label.setPosition(110, 36)
    btn.addChild(label)
    let uiButton = UIButton.create(btn, true)
    uiButton.on(UIButtonEvent.Click, function(){
        self.onClose(closeCb)
    })
    ButtonPushBounceAnim.create(uiButton)

}

PrivacyPanel.prototype.initTxt = function (entry) {
    let self = this

    self.titleTxt = ""

    if (entry == "userAgreement") {
        self.titleTxt = self.privacy_config["privacy.user_agreement.title"]
    } else {
        self.titleTxt = self.privacy_config["privacy.privacy_policy.title"]

    }

    let title = cc.Label.createWithSystemFont(self.titleTxt, "微软雅黑", 33)
    title.setTextColor(cc.c4b(57, 112, 145, 255))
    title.setPosition(340, 890)
    self.bg.addChild(title)
    console.log("privacy title", title)

    self.scrollview = ccui.ScrollView.create()
    self.scrollview.setContentSize(cc.size(TextAreaWidth, TextAreaHeight))
    self.scrollview.setPosition(cc.p(60, 180))
    self.scrollview.setDirection(ccui.ScrollViewDir.vertical)
    self.scrollview.setBounceEnabled(true)

    self.bg.addChild(self.scrollview)
    
    TopAreaHeight = $len(RES)*perlength //长度
    self.scrollview.setInnerContainerSize(cc.size(TextAreaWidth, TopAreaHeight))


    // 初始化创建
    self.itmePosList = []
    let initNum = 3
    for (let i = 0; i < initNum; i++) {
        self.createItem(i)
    }
    

    self.scrollview.addEventListener(function (view, event) {
        if (event == ccui.ScrollView.EVENT_CONTAINER_MOVED){
            let children = view.getChildren();
            let innerContainer = view.getInnerContainer()
            for (let i = 0; i < children.length; i++) {
                let item = children[i] 
                let wp = innerContainer.convertToWorldSpace(cc.p(item.getPosition()))
                let lp = view.convertToNodeSpace(wp)
                let msg = self.itmePosList[i]
                if (lp.y-msg.height > 650 || lp.y < 0){
                    item.removeAllChildren()
                }else{
                    self.createShowLabel(i,item)
                }
                if (i == children.length -1 && i < $len(RES)-1){
                    if (lp.y > 0){
                        self.createItem(i+1)
                    }
            }
        }

        }
    });


}
PrivacyPanel.prototype.createShowLabel = function (index,node) {
    if (!node || node.getChildByName("img")){
        return
    }
    
    let img = cc.Sprite.createWithSpriteFrameName(RES[index + 1])
    img.setPosition(img.getContentSize().width/2, img.getContentSize().height/2)
    img.setName("img")
    node.addChild(img)

}

PrivacyPanel.prototype.createItem = function (index) {
    let self = this

    let img = cc.Sprite.createWithSpriteFrameName(RES[index + 1])
    let node = cc.Node.create()
    node.setContentSize(img.getContentSize())
    node.addChild(img)
    img.setPosition(img.getContentSize().width/2,img.getContentSize().height/2)
    img.setName("img")


    let children = self.scrollview.getChildren();
    let onItem = children[index-1]

    let onMsg = self.itmePosList[index-1]
    let posY = TopAreaHeight
    if (onItem) {
        posY = onItem.y - onMsg.height
    }
    node.setAnchorPoint(0,1)
    node.setPositionY(posY)
    self.itmePosList.push({
        posY:posY,
        height:node.getContentSize().height 
    })

    self.scrollview.addChild(node)

    return node
}

module.exports = PrivacyPanel